import React, { useState, useEffect } from "react";
import {
  Box,
  Grid2,
  Typography,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Dialog
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HeaderBack from "../Header_Back";
import events2 from "../../assets/images/events_2.png";
import Minus from "../../assets/images/minus.svg";
import Plus from "../../assets/images/plus.svg";
import { useNavigate, useParams } from "react-router-dom";
import Snackbars from "../../utils/Snackbars";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";

const Eventresellticketbooking = () => {
  const { r_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest, postRequest } = useRequests();
  const [isProcessing, setIsProcessing] = useState(false);
  const [open, setOpen] = useState(false);

  const TokenDetails = JSON.parse(localStorage.getItem("userDetails"));

  const eventDetails = {
    title: "Raas Ratri : A Night of Dance and Devotion",
    duration: "10 Day's Events",
  };
  const [day, setDay] = React.useState("1");
  const handleChange = (event) => {
    setDay(event.target.value);
  };
  const [value] = React.useState(null);
  const [quantity, setQuantity] = useState(1);
  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };
  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const handleBuyTicket = (ut_id) => {
    navigate(`/resell-market/ticket-list/book-ticket/confirmation/${ut_id}`);
  };

  const onSubmit = async () => {
    // e.preventDefault();

    try {
      if (TokenDetails.guestMode == true) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "Please login to purchase the ticket",
        }));
        resetAlertData();
        return;
      }
      if (
        detail.aadhar == "" ||
        detail.aadhar == undefined ||
        detail.aadhar == null
      ) {
        setAlertData({
          variant: "error",
          message: "Update Aadhaar in Profile to Book from Resell Market!",
        });
        resetAlertData();
        return;
      }

      if(balance>=detail.final_resale_price){
        if(open == false){
            setOpen(true);
            return;
        }
      }

      setIsProcessing(true); // Start processing

      
      if(balance>=detail.final_resale_price){
          setOpen(false);
          const jsonpar = {
            r_id: r_id,
            quantity: detail.resale_quantity,
            amount: detail.final_resale_price,
            platform_fees: detail.only_fees,
            gst: detail.only_gst,
            tcs: detail.only_tcs,
          };
          
          const validateRes = await postRequest("purchase-resell-ticket-wallet", JSON.stringify(jsonpar));
          if (validateRes && validateRes.code === 200) {
            setIsProcessing(false); // Stop processing
            handleBuyTicket(validateRes.data.ut_id);
          }
          else {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: validateRes.message || "Failed to purchase ticket.",
            }));
            resetAlertData();
            setIsProcessing(false); // Stop processing
            return;
        }
      }else{
      const referralCode = localStorage.getItem("referralCode") || "";
      const jsonpar = JSON.stringify({
        r_id: r_id,
        quantity: detail.resale_quantity,
        amount: detail.final_resale_price,
        platform_fees: detail.only_fees,
        gst: detail.only_gst,
        tcs: detail.only_tcs,
        referral_code: referralCode
      });

      const res = await postRequest("purchase-resell-ticket-validate", jsonpar);

      if (res && res.code === 200) {
        if (!res.data.id) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message || "Failed to purchase ticket.",
          }));
          resetAlertData();
          return;
        } else {
          let amount = detail.final_resale_price * 100;
          let currency = "INR";
          var options = {
            key: process.env.REACT_APP_RAZORPAY_KEY_ID,
            amount,
            currency,
            name: "Peacockverse",
            description: "Ticket Purchase Transaction",
            order_id: res.data.id,
            method: {
              upi: true,
            },
            handler: async function (response) {
              setIsProcessing(true); // Start processing after payment is successful

              const body = {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                r_id: r_id,
                quantity: detail.resale_quantity,
                amount: detail.final_resale_price,
                platform_fees: detail.only_fees,
                gst: detail.only_gst,
                tcs: detail.only_tcs,
                adminfees: res.data.adminfees,
                organizerfees: res.data.organizerfees,
                organizerfeesbywallet: res.data.organizerfeesbywallet,
                paid_by_wallet: res.data.paid_by_wallet,
                paid_by_gateway: res.data.paid_by_gateway,
                referral_code: referralCode,
                transaction_id: res.data.transaction_id
              };

              const validateRes = await postRequest(
                "purchase-resell-ticket",
                JSON.stringify(body)
              );
              if (validateRes && validateRes.code === 200) {
                setIsProcessing(false); // Stop processing
                handleBuyTicket(validateRes.data.ut_id);
              } else {
                setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: "error",
                  message: validateRes.message || "Failed to purchase ticket.",
                }));
                resetAlertData();
                setIsProcessing(false); // Stop processing
                return;
              }
            },
            prefill: {
              "contact": TokenDetails.phone,
            },
            notes: {
              "transaction_id": res.data.transaction_id,
              "address": "Razorpay Corporate Office",
            },
            theme: {
              "color": "#3399cc",
            },
          };
          var rzp1 = new window.Razorpay(options);
          rzp1.on("payment.failed", function (response) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: "error",
              message:
                response.error.description || "Failed to purchase ticket.",
            }));
            resetAlertData();
            return;
            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
          });
          rzp1.open();
          // e.preventDefault();
        }
      } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: res.message || "Failed to purchase ticket.",
        }));
        resetAlertData();
      }
    }
    } catch (error) {
      console.log(error);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "error",
        message: "An error occurred while purchase ticket",
      }));
      resetAlertData();
    }
    finally {
      setIsProcessing(false); // Stop processing in finally block
    }
  };

  const [detail, setDetail] = useState({
    type: "",
    day_pass: "",
    quantity: "",
    resale_quantity: "",
    resold_quantity: "",
    name: "",
    address: "",
    start_datetime: "",
    end_datetime: "",
    time: "",
    banner: "",
    event_ticket_date: "",
    purchase_price: "",
    resale_price: "",
    purchase_date: "",
    final_resale_price: "",
    only_fees: "",
    only_gst: "",
    only_tcs: "",
    aadhar:""
  });

  const fetchResaleTicketDetails = async (GST,TCS) => {
    setLoading(true);
    try {
      const response = await getRequest(`resell-ticket-details/${r_id}`);
      if (response && response.code === 200) {
        const data = response.data;
        const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
        setMaxEventDays(calculatedMaxDays);
        setplatform_fees(data.platform_fees_percentage)
        setplatform_fees_fixed(data.platform_fees_fixed)
        setplatform_fees_type(data.platform_fees_type)
        let TicketPrice;
        if(data.platform_fees_type == "Fixed"){
            TicketPrice =  Number(data.resale_price) + Number(data.platform_fees_fixed);
        }else{
          TicketPrice =  Number(data.resale_price) + (Number(data.resale_price) * Number(data.platform_fees_percentage)) / 100; 
        }
        let gstfee = 0
        let tcsfee = 0
        if(data.gst_flag == true){
          if(data.platform_fees_type == "Fixed"){
            gstfee = (((Number(data.platform_fees_fixed)) * GST) /100)
          }else{
            gstfee = ((((Number(data.resale_price) * Number(data.platform_fees_percentage)) / 100) * GST) /100)
          }
        }
        if(data.tcs_flag == true){
          tcsfee =  (((Number(data.resale_price)) * TCS) /100)
        }

        TicketPrice = Number(TicketPrice) + Number(gstfee) + Number(tcsfee)
        let OnlyFees = (Number(data.resale_price) * Number(data.platform_fees_percentage)) / 100;
        if(data.platform_fees_type == "Fixed"){
          OnlyFees = Number(data.platform_fees_fixed);
        }
        setDetail({
          type: data.type,
          day_pass: data.day_pass,
          quantity: data.quantity,
          resale_quantity: data.resale_quantity,
          resold_quantity: data.resold_quantity,
          name: data.name,
          address: data.address,
          start_datetime: data.start_datetime,
          end_datetime: data.end_datetime,
          time: data.start_time + " - " + data.end_time,
          banner: data.banner,
          event_ticket_date: data.event_ticket_date,
          purchase_price: data.purchase_price,
          resale_price: data.resale_price,
          purchase_date: data.purchase_date,
          final_resale_price: TicketPrice,
          only_fees: OnlyFees,
          only_gst: gstfee,
          only_tcs: tcsfee,
          aadhar: data.aadhar,
          gst_flag: data.gst_flag,
          tcs_flag: data.tcs_flag,
          basic_ticket_price: Number(data.resale_price),
          ticket_time: data.time
        });
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch ticket details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

  const [platform_fees, setplatform_fees] = useState();
  const [platform_fees_fixed, setplatform_fees_fixed] = useState();
  const [platform_fees_type, setplatform_fees_type] = useState();

  const [balance, setBalance] = useState("0.00");
  const fetchWalletBalance = async () => {
      setLoading(true);
      const response = await getRequest("user-wallet");
      if (response && response.code === 200) {
        console.log(response)
          if(response.data[0]){
              setBalance(response.data[0].balance)
          }
          
      } else {
          setAlertData({ variant: "error", message: "Failed to fetch wallet balance" });
          resetAlertData();
      }
  };

    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };

    const [gst, setGst] = useState();
        const [tcs, setTcs] = useState();
        const fetchSettings = async () => {
        const response = await getRequest("site-settings");
        if (response && response.code === 200) {
          let GST = 0;
          let TCS = 0;
          response.data.forEach(element => {
            if(element.setting_name == "gst"){
                setGst(element.setting_value);
                GST = element.setting_value;
            }
            if(element.setting_name == "tcs"){
                setTcs(element.setting_value);
                TCS = element.setting_value;
            }
          });
            fetchResaleTicketDetails(GST,TCS);
          
        } else {
          setAlertData({ variant: "error", message: "Failed to fetch settings" });
          resetAlertData();
        }
      };

  useEffect(() => {
    fetchWalletBalance();
    fetchSettings();
  }, [r_id]);

  const formatEventDate = (start, end, time, ticketDate, purchase_date) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();
    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    const purchaseDate = new Date(purchase_date);
    const purchaseDay = format(purchaseDate, "dd");
    const purchaseMonth = format(purchaseDate, "MM");
    const purchaseYear = format(purchaseDate, "yyyy");
    const formatedPurchaseDate = `${purchaseDay}/${purchaseMonth}/${purchaseYear}`;

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
        formatedPurchaseDate: formatedPurchaseDate,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      formatedPurchaseDate: formatedPurchaseDate,
    };
  };

  if (!detail) return <Typography>No ticket details found.</Typography>;
  let formatedData = {};
  if (!loading) {
    formatedData = formatEventDate(
      detail.start_datetime,
      detail.end_datetime,
      detail.time,
      detail.event_ticket_date,
      detail.purchase_date
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid2 className="center-App" container direction="column">
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <HeaderBack name="Resell Book Ticket" eventimg={detail.banner} backdisable={isProcessing}/>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "300px",
            }}
          >
            <CircularProgress color="primary" />
            <p>Loading ...</p>
          </Box>
        ) : (
          <Box sx={{ padding: "15px 15px", float: "left", width: "100%" }}>
            <Grid2 container spacing={2}>
              <Grid2 item xs={12} sx={{ float: "left", width: "100%" }}>
                <Grid2 className="events-time">
                  {" "}
                  <Typography
                    sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}
                  >
                    {maxEventDays}  Day's Event
                  </Typography>
                </Grid2>
                <Typography
                  variant="h2"
                  className="title"
                  sx={{
                    marginBottom: "-5px",
                    fontSize: "32px",
                    marginTop: "20px",
                    color: "#6638A2",
                    fontWeight: "500",
                  }}
                >
                  {" "}
                  {detail.name}
                </Typography>
              </Grid2>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid2
                    item
                    xs={12}
                    className="fullWidth"
                    sx={{ marginTop: "12px" }}
                  >
                    <Grid2 className="event-info">
                      <Typography
                        variant="h4"
                        className="title"
                        sx={{ marginTop: "20px" }}
                      >
                        Ticket Information
                      </Typography>
                      <Grid2 className="event-info">
                        <Grid2 className="event-des fullWidth">
                          <Typography
                            sx={{
                              color: "#747688",
                              fontSize: "13px,",
                              fontWeight: "500",
                            }}
                          >
                            Ticket Type
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 500,
                              color: "#120D26",
                            }}
                          >{`${detail.type} Ticket, ${detail.day_pass} Day Pass, ${detail.resale_quantity} Person`}</Typography>
                        </Grid2>
                      </Grid2>
                      <Grid2 className="event-info">
                        <Grid2 className="event-des fullWidth">
                          <Typography
                            sx={{
                              color: "#747688",
                              fontSize: "13px,",
                              fontWeight: "500",
                            }}
                          >
                            Event Date/Time
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 500,
                              color: "#120D26",
                            }}
                          >
                            {detail.day_pass == 1
                              ? `${formatedData.ticketFormatedDate}, ${detail.ticket_time ? detail.ticket_time : formatedData.time}`
                              : `${formatedData.formattedDate}, ${detail.ticket_time ? detail.ticket_time : formatedData.time}`}
                          </Typography>
                        </Grid2>
                      </Grid2>
                      {/* <Grid2 className="event-info event-info-half-width">
                        <Grid2 className="event-des fullWidth">
                          <Typography
                            sx={{
                              color: "#747688",
                              fontSize: "13px,",
                              fontWeight: "500",
                            }}
                          >
                            Purchase Price
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 500,
                              color: "#120D26",
                            }}
                          >{`₹${
                            detail.resale_quantity *
                            (Number(detail.purchase_price) /
                              (Number(detail.quantity) +
                                Number(detail.resold_quantity)))
                          }`}</Typography>
                        </Grid2>
                      </Grid2>
                      <Grid2 className="event-info event-info-half-width">
                        <Grid2 className="event-des fullWidth">
                          <Typography
                            sx={{
                              color: "#747688",
                              fontSize: "13px,",
                              fontWeight: "500",
                            }}
                          >
                            Purchase Date
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 500,
                              color: "#120D26",
                            }}
                          >
                            {formatedData.formatedPurchaseDate}
                          </Typography>
                        </Grid2>
                      </Grid2> */}
                      <Grid2 className="event-info">
                        <Grid2 className="event-des fullWidth">
                          <Typography
                            sx={{
                              color: "#747688",
                              fontSize: "13px,",
                              fontWeight: "500",
                            }}
                          >
                            Location
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "19px",
                              fontWeight: 500,
                              color: "#120D26",
                            }}
                          >
                            {detail.address}
                          </Typography>
                        </Grid2>
                      </Grid2>

                      <Grid2 className="event-info">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            Ticket Price :
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            ₹
                            {Number(detail.basic_ticket_price).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid2>

                      <Grid2
                        className="event-info"
                        style={{ marginTop: "5px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            Platform Fees :
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            ₹{Number(detail.only_fees).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid2>

                      {detail.gst_flag == true?
                                            <Grid2
                        className="event-info"
                        style={{ marginTop: "5px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            GST :
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            ₹{Number(detail.only_gst).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid2>
                      :""}

                      {detail.tcs_flag == true?
                                            <Grid2
                        className="event-info"
                        style={{ marginTop: "5px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            TCS :
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                            }}
                          >
                            ₹{Number(detail.only_tcs).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid2>
                      :""}

                      <Grid2
                        className="event-info"
                        style={{ marginTop: "5px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                              fontWeight: "bold",
                            }}
                          >
                            Total Amount :
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "16px",
                              color: "#341439",
                              fontWeight: "bold",
                            }}
                          >
                            ₹{Number(detail.final_resale_price).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid>
              </Grid>
            </Grid2>
            <Grid className="button-bottom fullWidth" fullWidth>
              <Button
                className="btn-common"
                variant="contained"
                color="primary"
                fullWidth
                onClick={onSubmit}
              >
                {isProcessing ? "Processing..." : `Book Ticket ₹${Number(detail.final_resale_price).toFixed(2)}`}
              </Button>
            </Grid>
          </Box>
        )}
      </Grid2>
                        <Dialog open={open} onOpenChange={setOpen}>
                          <div
                            className="install-modal"
                            style={{
                              zIndex: 111,
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background: "rgba(0, 0, 0, 0.7)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                background: "white",
                                padding: "25px 10px 30px",
                                borderRadius: "10px",
                                textAlign: "center",
                                width: "100%",
                                maxWidth: "430px",
                                margin: "0 10px",
                              }}
                            >
                              <p style={{ fontSize: "20px", marginTop: "8px" }}>
                                Wallet Balance :  {balance} Rs
                              </p>
                              <p style={{ fontSize: "20px", marginTop: "8px" }}>
                                Are you sure you want book ticket?
                              </p>
                              <button
                                id="submit1"
                                onClick={onSubmit}
                                style={{
                                  background: "#6638A2",
                                  border: "none",
                                  padding: "4px 25px",
                                  fontSize: "18px",
                                  color: "#fff",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                Book
                              </button>
                              <button
                                onClick={() => setOpen(false)}
                                style={{
                                  marginLeft: "10px",
                                  background: "#EFEFEF",
                                  border: "none",
                                  padding: "4px 25px",
                                  fontSize: "18px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </Dialog>
    </Box>
  );
};

export default Eventresellticketbooking;
